export const GAS_ABSTRACTION_FEE_TITLE = "Gas Payment";
export const GAS_ABSTRACTION_FEE_SUBTITLE = "Paymaster Fee";

export function getGasAbstractionFeePlainLabel() {
  return `${GAS_ABSTRACTION_FEE_TITLE} · ${GAS_ABSTRACTION_FEE_SUBTITLE}`;
}

export function getGasAbstractionFeeSubtitle() {
  return GAS_ABSTRACTION_FEE_SUBTITLE;
}
